import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { transform } from 'ol/proj';
import MapConstants from '../../../features/map/models/map-constants';
import { CustomCoordinate } from '../../models/customCoordinate';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PositionService {
  private baseUrl = environment.exploreURL;

  constructor(private httpClient: HttpClient) { }

  async transformeCoordinates(coordX: number, coordY: number, epsgIn: string, isDegre: boolean = false): Promise<CustomCoordinate> {
    try {
      var coordtrans = await lastValueFrom(this.httpClient.put<CoordinateTransform>(
        `${this.baseUrl}/api/sites/TransformCoordinate`, { coordX, coordY, EPSGin: 4326, EPSGout: parseInt(epsgIn, 10) }
      ));

      return {
        coordX: isDegre ? coordtrans.coordX.toFixed(4) : coordtrans.coordX.toFixed(0),
        coordY: isDegre ? coordtrans.coordY.toFixed(4) : coordtrans.coordY.toFixed(0),
      } as CustomCoordinate;
    } catch (error) {
      console.error("Erreur lors de la transformation des coordonnées : ", error);
      return { coordX, coordY } as CustomCoordinate;
    }
  }


  public transforme(coordX: number, coordY: number, epsgIn: string, isDegre: boolean = false): CustomCoordinate {
    try {
      let coordtrans = transform([coordX, coordY], MapConstants.EPSG_WGS84, "EPSG:" + epsgIn);
      return {
        coordX: isDegre ? coordtrans[0].toFixed(4) : coordtrans[0].toFixed(0),
        coordY: isDegre ? coordtrans[1].toFixed(4) : coordtrans[1].toFixed(0),
      } as CustomCoordinate;
    } catch (error) {
      console.error("Erreur lors de la transformation des coordonnées : ", error);
      return {
        coordX: coordX,
        coordY: coordY,
      } as CustomCoordinate;
    }
  }
}

export interface CoordinateTransform {
  EPSGin: number;
  EPSGout: number;
  coordX: number;
  coordY: number;
}

